import React from "react"
import styled from "styled-components"
import Button from "../Button"

export default function OpCard({
  id,
  title,
  desc,
  content,
  table,
  opcard,
  setOpcard
}) {
  const opcardHolder = () => {
    opcard === id ? setOpcard("") : setOpcard(id)
  }

  return (
    <Card className={opcard === id ? "active" : ""}>
      <div className="opcardInfo" onClick={opcardHolder}>
        <div className="titleWrapper">
          <h3 className="text-gradient">{title}</h3>
          <p>{desc}</p>
        </div>
        <div className="toggleBtn">
          <div />
          <div />
        </div>
      </div>
      <div className="info">
        {content?.map(({ title, content }) => (
          <div key={title}>
            <h3 className="text-gradient">{title}</h3>
            <p>{content}</p>
          </div>
        ))}
        <div className="line" />
        <div className="cardTable">
          {table?.map(({ title, content }) => (
            <div key={title}>
              <h3 className="">{title}</h3>
              <p>{content}</p>
            </div>
          ))}
        </div>
      </div>
      <a
        className="btnWrapper"
        href={`mailto:hr@kryptogo.app?subject=應徵KryptoGO "${title}"`}
      >
        <Button title="Apply" />
      </a>
    </Card>
  )
}

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0px;
  max-width: 1000px;
  width: 100%;
  padding: 30px;
  border-radius: 30px;
  border: 1px solid #ffc411;
  overflow: hidden;
  /* height: 114px; */
  transition: 0.3s ease-in-out;
  .toggleBtn {
    width: 15px;
    height: 15px;
    position: relative;
    transform: rotate(90deg);
    transition: all 0.3s;
    z-index: 20;
    cursor: pointer;
    div:nth-child(1) {
      transition: 0.3s ease-in-out;
      position: absolute;
      width: 16px;
      height: 3px;
      top: 50%;
      background-color: #ffc411;
      transform: translateY(calc(-50% - 4.6px)) rotate(45deg);
    }
    div:nth-child(2) {
      transition: 0.3s;
      position: absolute;
      width: 16px;
      height: 3px;
      top: 50%;
      background-color: #ffc411;
      transform: translateY(calc(-50% + 4.6px)) rotate(-45deg);
    }
  }
  > div {
    display: flex;
    flex-direction: column;
    gap: 20px;
    transition: 0.3s ease-in-out;
    width: 100%;
    &.opcardInfo {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      .titleWrapper {
        display: flex;
        flex-direction: column;
        /* gap: 10px; */
      }
    }
    &.info {
      overflow: hidden;
      height: 0px;
      opacity: 0;
    }
  }
  .btnWrapper {
    height: 0px;
    overflow: hidden;
    opacity: 0;
    max-width: 300px;
    text-align: center;
    /* width: 200px; */
    transition: 0.3s ease-in-out;
    width: 100%;
    transition: 0.3s ease-in-out;
    justify-content: center;
    z-index: 20;
    margin: 0 auto;
  }
  .cardTable {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    /* border-top:1px solid #ffc411; */
    h3 {
      font-size: 16px;
      color: #ffc411;
      display: inline-block;
      margin-right: 10px;
    }
    p {
      display: inline-block;
      font-size: 16px;
    }
    @media (max-width: 1000px) {
      grid-template-columns: 1fr;
    }
  }
  h3 {
    margin: 0px 0 10px 0;
    line-height: 1.5;
    /* background-color: #fff; */
  }
  p {
    margin: 0;
    line-height: 1.5;
    /* background-color: #fff; */
  }
  &.active {
    box-shadow: 0px 0px 15px #ffc41181;
    .toggleBtn {
      /* div:nth-child(1){
        transform:translateY(calc(-50%)) rotate(45deg) ;
      }
      div:nth-child(2){
        transform:translateY(calc(-50%)) rotate(-45deg) ;
      } */
      transform: rotate(-90deg);
    }
    > div:nth-child(2) {
      height: 50vh;
      overflow: auto;
      margin-top: 30px;
      padding: 20px 0 0 0;
      border-top: 0.5px solid #ffc41171;
      opacity: 1;

      /* 這邊設置拉桿css */
      ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: none;
      }

      ::-webkit-scrollbar {
        width: 2px;
        background-color: none;
      }

      ::-webkit-scrollbar-thumb {
        background: linear-gradient(#ffc411, #ffebaf);
        border-radius: 5px;
      }
    }
    .btnWrapper {
      margin: 20px auto 0 auto;
      height: 54px;
      opacity: 1;
      overflow: visible;
    }
  }
  .line {
    width: 100%;
    /* height: 100px; */
    border-top: 0.5px solid #ffc41171;
    padding: 0px;
    margin: 30px 0;
  }
  li {
    padding-left: 25px;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-top: 10px;
      top: 0;
      left: 5px;
      background-color: #ffc411;
    }
  }
`
